<template>
  <validation-observer v-slot="{ handleSubmit, reset }">
    <form @submit.prevent="handleSubmit(submitForm)" @reset.prevent="reset" class="main_form stepform_1">
      <div class="w-layout-grid">
        <div class="form_field">
          <validation-provider class="w-100" :name="$t('WHATIS_REGISTRATION_NUMBER')" rules="required|cypriot_license_plate" v-slot="{ errors, classes }">
            <div class="form_columns w-row">
              <div class="column-4 w-clearfix w-col w-col-9">
                <label class="field_label"><span v-html="$t('WHATIS_REGISTRATION_NUMBER')"></span></label>
              </div>
              <!-- <div class="column-13 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div> -->
              <help-text />
            </div>
            <div class="div_form_cell">
              <input
                v-model="data.CS_VEHICLE.LICENSE_PLATE"
                type="text"
                class="text_field_input text-field w-input"
                maxlength="256"
                placeholder="ABC123"
                name="WHATIS_REGISTRATION_NUMBER"
              />
            </div>
            <span :class="classes">{{ errors[0] }}</span>
          </validation-provider>
        </div>
        <div class="form_field">
          <validation-provider ref="VEHICLE_IS" class="w-100" :name="$t('VEHICLE_IS')" rules="required" v-slot="{ errors, classes }">
            <div class="form_columns w-row">
              <div class="field_column w-clearfix w-col w-col-9">
                <label class="field_label">{{ $t('VEHICLE_IS') }}</label>
              </div>
              <help-text header="Test" text="Test text" />
              <!-- <div class="column-12 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div> -->
            </div>
            <div class="form_columns split_form_columns w-row">
              <div class="field_column left w-col w-col-6" v-for="item in $h.getLov(data.ET_LOVS, 'VEHICLE_TYPE')" :key="item.VALUE">
                <label class="radio_gic w-radio">
                  <div :class="['w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input', data.CS_VEHICLE.VEHICLE_TYPE === item.VALUE && 'w--redirected-checked']"></div>
                  <input v-model="data.CS_VEHICLE.VEHICLE_TYPE" :value="item.VALUE" type="radio" />
                  <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
                </label>
              </div>
            </div>
            <span :class="classes">{{ errors[0] }}</span>
          </validation-provider>
        </div>
      </div>

      <div class="columns-7 w-row">
        <div class="column-20 w-col w-col-3"></div>
        <div class="column-19 w-col w-col-6">
          <p class="bold_label">
            {{ $t('VEHICLE_NOT_REGISTERED') }} <a href="javascript:;" class="link-3" @click="notRegistered">{{ $t('CLICK_HERE') }}</a>
          </p>
          <button type="submit" class="submit-button submit-button-2 main_button w-button">{{ $t('CONTINUE') }}</button>
        </div>
        <div class="column-21 w-col w-col-3"></div>
      </div>
    </form>
  </validation-observer>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async notRegistered() {
      const res = await this.$refs.VEHICLE_IS.validate();
      if (!res.valid) { return; }
      this.$emit('not-registered');
    },
    submitForm() {
      this.$emit('search-vehicle', { CS_VEHICLE: { LICENSE_PLATE: this.data.CS_VEHICLE.LICENSE_PLATE, VEHICLE_TYPE: this.data.CS_VEHICLE.VEHICLE_TYPE } });
    }
  },
};
</script>
